// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupedList_container__ALRpS","name":"GroupedList_name__36-Wy","icon":"GroupedList_icon__3Pt0s","open":"GroupedList_open__183lT","content":"GroupedList_content__3pnSp"};